module.exports = __webpack_public_path__ + "media/images/icon/icons8-Enter-9f4f1efe4695e21b579c9385f688523b.png";